import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuardService} from "./services/auth-guard.service";
import {IndexComponent} from './pages/index/index.component';
import {MainNewComponent} from './pages/main-new/main-new.component';
import {LoginComponent} from "./routes/auth/login/login.component";

const routes: Routes = [
  {
    path: '',
    component: IndexComponent,
    canActivate: [AuthGuardService],
    children: [
      {path: '', redirectTo: 'main', pathMatch: 'full'},
      {path: 'main', component: MainNewComponent, canActivate: [AuthGuardService]},

      {path: 'profile', loadChildren: () => import('./routes/profile/profile.module').then(m => m.ProfileModule)},
      {path: 'admin', loadChildren: () => import('./routes/admin/admin.module').then(m => m.AdminModule)},
      {path: 'report', loadChildren: () => import('./routes/report/report.module').then(m => m.ReportModule)},
    ]
  },
  {path: 'login', component: LoginComponent},
  {path: 'auth', loadChildren: () => import('./routes/auth/auth.module').then(m => m.AuthModule)},
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      relativeLinkResolution: 'legacy',
      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'enabled'
    }),
  ],
  exports: [
    RouterModule,
  ],
  providers: []

})
export class AppRoutingModule {
}
